export const SETUP_DISCORD = 'SETUP_DISCORD';
export const UPDATE_DISCORD_PROFILE = 'UPDATE_DISCORD_PROFILE';
export const RESET_DISCORD_STATE = 'RESET_DISCORD_STATE';
